(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1764],{

/***/ 12141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CH": function() { return /* binding */ loadTagInfoBySlug; },
/* harmony export */   "Od": function() { return /* binding */ loadBrand; },
/* harmony export */   "Z$": function() { return /* binding */ loadEfficacyCombinedList; },
/* harmony export */   "o1": function() { return /* binding */ loadCategoryList; },
/* harmony export */   "s8": function() { return /* binding */ loadEfficacyList; },
/* harmony export */   "t9": function() { return /* binding */ loadTabDetail; },
/* harmony export */   "wu": function() { return /* binding */ loadManufacturerInfoBySlug; }
/* harmony export */ });
/* unused harmony export loadCategoryInfoBySlug */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var constants_manufacturer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59893);
/* harmony import */ var _Clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38307);




var PRODUCT_API_PREFIX = "/marketplace/product/v2";
function loadBrand(_) {
    return _loadBrand.apply(this, arguments);
}
function _loadBrand() {
    _loadBrand = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var ctx, params, ref, res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, params = param.params;
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .GET_ALL */ .Ks)((_tmp.ctx = ctx, _tmp.url = "".concat(PRODUCT_API_PREFIX, "/manufacturer/list"), _tmp.isBasic = true, _tmp.params = params, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(res)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                            return constants_manufacturer__WEBPACK_IMPORTED_MODULE_3__/* .TopManufacturer.indexOf */ .j.indexOf(item.code) >= 0;
                        }).sort(function(a, b) {
                            var ref, ref1;
                            return ((a === null || a === void 0 ? void 0 : (ref = a.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "").localeCompare((b === null || b === void 0 ? void 0 : (ref1 = b.name) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || "");
                        })
                    ];
            }
        });
    });
    return _loadBrand.apply(this, arguments);
}
function loadCategoryList() {
    return _loadCategoryList.apply(this, arguments);
}
function _loadCategoryList() {
    _loadCategoryList = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ctx, _tmp, ref, res, _tmp1;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    ctx = (_arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : _tmp).ctx;
                    _tmp1 = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .GET */ .HT)((_tmp1.ctx = ctx, _tmp1.url = "".concat(PRODUCT_API_PREFIX, "/category/list"), _tmp1.isBasic = true, _tmp1.params = {
                            getCache: true,
                            limit: 1000
                        }, _tmp1))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(res)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
                            var ref, ref1;
                            return ((a === null || a === void 0 ? void 0 : (ref = a.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "").localeCompare((b === null || b === void 0 ? void 0 : (ref1 = b.name) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || "");
                        })
                    ];
            }
        });
    });
    return _loadCategoryList.apply(this, arguments);
}
function loadEfficacyList() {
    return _loadEfficacyList.apply(this, arguments);
}
function _loadEfficacyList() {
    _loadEfficacyList = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ctx, _tmp, res, _tmp1;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    ctx = (_arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : _tmp).ctx;
                    _tmp1 = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .GET */ .HT)((_tmp1.ctx = ctx, _tmp1.url = "".concat(PRODUCT_API_PREFIX, "/efficacy/list"), _tmp1.isBasic = true, _tmp1.params = {
                            getCache: true,
                            limit: 1000
                        }, _tmp1))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(res)
                    ];
            }
        });
    });
    return _loadEfficacyList.apply(this, arguments);
}
function loadEfficacyCombinedList() {
    return _loadEfficacyCombinedList.apply(this, arguments);
}
function _loadEfficacyCombinedList() {
    _loadEfficacyCombinedList = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ctx, _tmp, res, _tmp1;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    ctx = (_arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : _tmp).ctx;
                    _tmp1 = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .GET */ .HT)((_tmp1.ctx = ctx, _tmp1.url = "".concat(PRODUCT_API_PREFIX, "/efficacy-combined/list"), _tmp1.isBasic = true, _tmp1.params = {
                            getCache: true,
                            limit: 1000
                        }, _tmp1))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(res)
                    ];
            }
        });
    });
    return _loadEfficacyCombinedList.apply(this, arguments);
}
function loadCategoryInfoBySlug(_) {
    return _loadCategoryInfoBySlug.apply(this, arguments);
}
function _loadCategoryInfoBySlug() {
    _loadCategoryInfoBySlug = _async_to_generator(function(param) {
        var ctx, slug, res, _tmp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, slug = param.slug;
                    _tmp = {};
                    return [
                        4,
                        GET((_tmp.ctx = ctx, _tmp.url = "".concat(PRODUCT_API_PREFIX, "/category"), _tmp.params = {
                            q: JSON.stringify({
                                slug: slug
                            })
                        }, _tmp.isBasic = true, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        getData(res)
                    ];
            }
        });
    });
    return _loadCategoryInfoBySlug.apply(this, arguments);
}
function loadManufacturerInfoBySlug(_) {
    return _loadManufacturerInfoBySlug.apply(this, arguments);
}
function _loadManufacturerInfoBySlug() {
    _loadManufacturerInfoBySlug = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var slug, res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    slug = param.slug;
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .GET */ .HT)((_tmp.url = "".concat(PRODUCT_API_PREFIX, "/manufacturer"), _tmp.params = {
                            q: JSON.stringify({
                                slug: slug
                            })
                        }, _tmp.isBasic = true, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(res)
                    ];
            }
        });
    });
    return _loadManufacturerInfoBySlug.apply(this, arguments);
}
function loadTagInfoBySlug(_) {
    return _loadTagInfoBySlug.apply(this, arguments);
}
function _loadTagInfoBySlug() {
    _loadTagInfoBySlug = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var slug, res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    slug = param.slug;
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .GET */ .HT)((_tmp.url = "".concat(PRODUCT_API_PREFIX, "/tag/list"), _tmp.isBasic = true, _tmp.params = {
                            q: JSON.stringify({
                                slug: slug
                            })
                        }, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(res)
                    ];
            }
        });
    });
    return _loadTagInfoBySlug.apply(this, arguments);
}
function loadTabDetail(_) {
    return _loadTabDetail.apply(this, arguments);
}
function _loadTabDetail() {
    _loadTabDetail = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var ctx, params, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            ctx = param.ctx, params = param.params;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .GET */ .HT)((_tmp.ctx = ctx, _tmp.url = "".concat(PRODUCT_API_PREFIX, "/tabs/active"), _tmp.isBasic = true, _tmp.params = params, _tmp))
            ];
        });
    });
    return _loadTabDetail.apply(this, arguments);
}


/***/ }),

/***/ 61828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NewBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Breadcrumbs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7885);
/* harmony import */ var _material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98121);
/* harmony import */ var _mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18979);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90512);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62667);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_6__);







function NewBreadcrumbs(param) {
    var _breadcrumbs = param.breadcrumbs, breadcrumbs = _breadcrumbs === void 0 ? [] : _breadcrumbs, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var last = breadcrumbs.length > 0 ? breadcrumbs.length - 1 : 0;
    if (isLoading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            variant: "text",
            width: 450,
            height: 25
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Breadcrumbs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        separator: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            fontSize: "small"
        }),
        "aria-label": "breadcrumb",
        children: breadcrumbs && breadcrumbs.length > 0 && breadcrumbs.map(function(item, i) {
            return i === last ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().item_breadcrumb), (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().last_breadcrumb)),
                children: item.name
            }, "".concat(item.name).concat(i)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: item.url,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().item_breadcrumb),
                    children: item.name
                })
            }, "".concat(item.name).concat(i));
        })
    });
};


/***/ }),

/***/ 59893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ TopManufacturer; }
/* harmony export */ });
var TopManufacturer = [
    "A6EQ1PGEQ1",
    "F2V84FW961",
    "HXDBCV84FW",
    "TA2AXHR2AX",
    "UD72AXHR2A",
    "KVPGEQ1PGE",
    "8LCV84FW96",
    "TTYJYJYJYJ",
    "2E84FW961P",
    "G8T61PGEQ1",
    "H8R2AXHR2A",
    "WHJYJYJYJY",
    "BVPGEQ1PGE",
    "DUU72AXHR2", 
];


/***/ }),

/***/ 95102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useCategories; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var clients_CatClientV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12141);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66225);
/* harmony import */ var utils_ArrUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33769);
/* harmony import */ var utils_localStorageUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49327);








function useCategories() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ttl = ref.ttl, ttl = _ttl === void 0 ? sysconfig__WEBPACK_IMPORTED_MODULE_2__/* .TTL_CACHE_SERVER */ .dq * 1000 : _ttl;
    var FIELDS = [
        "code",
        "name",
        "slug",
        "subEfficacies",
        "relatedEfficacyCodes",
        "relatedSellerCategoryCodes",
        "relatedCategoryCodes",
        "icon"
    ];
    var getAllCategories = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var cachedCategories, ref, categoryList, efficacyList, efficacyCombinedList, combinedEfficacies, categories, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    cachedCategories = (0,utils_localStorageUtils__WEBPACK_IMPORTED_MODULE_4__/* .getWithExpiry */ .jE)(utils_localStorageUtils__WEBPACK_IMPORTED_MODULE_4__/* .CACHE_KEY.CATEGORIES */ .oy.CATEGORIES);
                    if (cachedCategories) {
                        return [
                            2,
                            cachedCategories.map(function(data) {
                                return (0,utils_localStorageUtils__WEBPACK_IMPORTED_MODULE_4__/* .deserializeFunc */ .OW)(data, FIELDS);
                            })
                        ];
                    }
                    return [
                        4,
                        Promise.all([
                            (0,clients_CatClientV2__WEBPACK_IMPORTED_MODULE_0__/* .loadCategoryList */ .o1)(),
                            (0,clients_CatClientV2__WEBPACK_IMPORTED_MODULE_0__/* .loadEfficacyList */ .s8)(),
                            (0,clients_CatClientV2__WEBPACK_IMPORTED_MODULE_0__/* .loadEfficacyCombinedList */ .Z$)()
                        ])
                    ];
                case 1:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), categoryList = ref[0], efficacyList = ref[1], efficacyCombinedList = ref[2];
                    combinedEfficacies = (efficacyCombinedList || []).reduce(function(acc, item) {
                        if (item.isActive) {
                            acc.push({
                                code: item.code,
                                name: item.name,
                                slug: item.slug,
                                relatedCategoryCodes: item.relatedCategoryCodes || [],
                                relatedEfficacyCodes: item.relatedEfficacyCodes || [],
                                relatedSellerCategoryCodes: item.relatedSellerCategoryCodes || [],
                                icon: item.icon
                            });
                        }
                        return acc;
                    }, []);
                    categories = (categoryList || []).reduce(function(acc, item) {
                        if (item.isActive) {
                            var subEfficacies = (efficacyList || []).reduce(function(effAcc, efficacy) {
                                if (efficacy.categoryCode === item.code) {
                                    effAcc.push({
                                        code: efficacy.code,
                                        name: efficacy.name,
                                        slug: efficacy.slug,
                                        categoryCode: efficacy.categoryCode,
                                        icon: efficacy.icon
                                    });
                                }
                                return effAcc;
                            }, []).concat(combinedEfficacies.filter(function(item) {
                                var ref;
                                return (ref = item.relatedCategoryCodes) === null || ref === void 0 ? void 0 : ref.includes(item.code);
                            }));
                            acc.push({
                                code: item.code,
                                name: item.name,
                                slug: item.slug,
                                subEfficacies: subEfficacies,
                                icon: item.icon
                            });
                        }
                        return acc;
                    }, []);
                    _tmp = {};
                    // Update cache
                    (0,utils_localStorageUtils__WEBPACK_IMPORTED_MODULE_4__/* .setWithExpiry */ .w4)(utils_localStorageUtils__WEBPACK_IMPORTED_MODULE_4__/* .CACHE_KEY.CATEGORIES */ .oy.CATEGORIES, categories.map(function(category) {
                        return (0,utils_localStorageUtils__WEBPACK_IMPORTED_MODULE_4__/* .serializeFunc */ .eX)(category, FIELDS);
                    }), (_tmp.ttl = ttl, _tmp));
                    return [
                        2,
                        categories
                    ];
            }
        });
    }), []);
    var getCategoryMapByCode = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var categories, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        getAllCategories((_tmp.ttl = ttl, _tmp))
                    ];
                case 1:
                    categories = _state.sent();
                    return [
                        2,
                        (0,utils_ArrUtils__WEBPACK_IMPORTED_MODULE_3__/* .convertArrayToMap */ .lE)(categories, "code")
                    ];
            }
        });
    }), []);
    return {
        getAllCategories: getAllCategories,
        getCategoryMapByCode: getCategoryMapByCode
    };
}


/***/ }),

/***/ 61533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ useManufacturers; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/clients/Clients.js + 1 modules
var Clients = __webpack_require__(38307);
;// CONCATENATED MODULE: ./src/clients/MasterDataClient.js



var PRODUCT_API_PREFIX = "/marketplace/product/v2";
var getManufacturer = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(code) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients/* GET */.HT)((_tmp.url = "".concat(PRODUCT_API_PREFIX, "/manufacturer"), _tmp.params = {
                    q: JSON.stringify({
                        code: code
                    })
                }, _tmp))
            ];
        });
    });
    return function getManufacturer(code) {
        return _ref.apply(this, arguments);
    };
}();
var getManufacturers = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var _offset, offset, _limit, limit, _ids, ids, _codes, codes, _getTotal, getTotal, isAuth, isBasic, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, _limit = param.limit, limit = _limit === void 0 ? 100 : _limit, _ids = param.ids, ids = _ids === void 0 ? [] : _ids, _codes = param.codes, codes = _codes === void 0 ? [] : _codes, _getTotal = param.getTotal, getTotal = _getTotal === void 0 ? false : _getTotal, isAuth = param.isAuth, isBasic = param.isBasic;
            _tmp = {};
            return [
                2,
                (0,Clients/* GET */.HT)((_tmp.url = "".concat(PRODUCT_API_PREFIX, "/manufacturer/list"), _tmp.params = {
                    offset: offset,
                    limit: codes.length > 0 ? ids.length > 0 ? ids.length : codes.length : limit,
                    ids: ids.join(","),
                    codes: codes.join(","),
                    getTotal: getTotal
                }, _tmp.isAuth = isAuth, _tmp.isBasic = isBasic, _tmp))
            ];
        });
    });
    return function getManufacturers(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/clients/WebServiceClient.js
var WebServiceClient = __webpack_require__(91952);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/localStorageUtils.js
var localStorageUtils = __webpack_require__(49327);
;// CONCATENATED MODULE: ./src/hooks/useManufacturers.js







var TTL = 24 * 60 * 60 * 1000; // 1 day in milliseconds
function useManufacturers() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ttl = ref.ttl, ttl = _ttl === void 0 ? TTL : _ttl;
    var FIELDS = [
        "code",
        "name",
        "slug",
        "shortName"
    ];
    (0,react.useEffect)(function() {
        // Remove old localStorage data
        localStorage.removeItem("manufactuers");
    }, []);
    var getManufacturerByCode = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(code) {
            var ref, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getManufacturerMapByCodes([
                                code
                            ])
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            2,
                            (ref = Object.values(data)) === null || ref === void 0 ? void 0 : ref[0]
                        ];
                }
            });
        });
        return function(code) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var getManufacturerMapByCodes = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(codes) {
            var manufacturers, _tmp, missingCodes, cachedManufacturers, _tmp1, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, code, manufacturer, res, _tmp2, _tmp3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        manufacturers = _tmp;
                        missingCodes = [];
                        _tmp1 = {};
                        cachedManufacturers = (0,localStorageUtils/* getWithExpiry */.jE)(localStorageUtils/* CACHE_KEY.MANUFACTURERS */.oy.MANUFACTURERS) || _tmp1;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = codes[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                code = _step.value;
                                if (cachedManufacturers[code]) {
                                    manufacturer = (0,localStorageUtils/* deserializeFunc */.OW)(cachedManufacturers[code], FIELDS);
                                    manufacturers[code] = manufacturer;
                                } else {
                                    missingCodes.push(code);
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (!(missingCodes.length > 0)) return [
                            3,
                            2
                        ];
                        _tmp2 = {};
                        return [
                            4,
                            getManufacturers((_tmp2.codes = missingCodes, _tmp2.isAuth = false, _tmp2.isBasic = true, _tmp2))
                        ];
                    case 1:
                        res = _state.sent();
                        _tmp3 = {};
                        if (res.status !== "OK") {
                            console.error("[Error] Get manufacturers", res);
                        } else {
                            res.data.forEach(function(manufacturer) {
                                var serializedData = (0,localStorageUtils/* serializeFunc */.eX)(manufacturer, FIELDS);
                                cachedManufacturers[manufacturer.code] = serializedData;
                                manufacturers[manufacturer.code] = (0,localStorageUtils/* deserializeFunc */.OW)(serializedData, FIELDS);
                            });
                            // Update cache
                            (0,localStorageUtils/* setWithExpiry */.w4)(localStorageUtils/* CACHE_KEY.MANUFACTURERS */.oy.MANUFACTURERS, cachedManufacturers, (_tmp3.ttl = ttl, _tmp3));
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2,
                            manufacturers
                        ];
                }
            });
        });
        return function(codes) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var getTopManufacturers = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data, result, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = (0,localStorageUtils/* getWithExpiry */.jE)(localStorageUtils/* CACHE_KEY.TOP_MANUFACTURERS */.oy.TOP_MANUFACTURERS);
                    if (!!data) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,WebServiceClient/* getTopManufacturerList */.ol)()
                    ];
                case 1:
                    result = _state.sent();
                    data = (0,Clients/* getData */.Yu)(result) || [];
                    _tmp = {};
                    if (data.length > 0) {
                        (0,localStorageUtils/* setWithExpiry */.w4)(localStorageUtils/* CACHE_KEY.TOP_MANUFACTURERS */.oy.TOP_MANUFACTURERS, data, (_tmp.ttl = ttl, _tmp));
                    }
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        data
                    ];
            }
        });
    }), []);
    return {
        getManufacturerByCode: getManufacturerByCode,
        getManufacturerMapByCodes: getManufacturerMapByCodes,
        getTopManufacturers: getTopManufacturers
    };
}


/***/ }),

/***/ 34831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var clients_MarketingClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13124);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36902);




var useCategoryFilterTree = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set, get) {
    return {
        categoryFilterTree: [],
        isLoading: false,
        isFetched: false,
        error: null,
        // Fetch the API
        fetchCategoryFilterTree: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            var state, _tmp, res, _tmp1, _tmp2, error, _tmp3;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state = get(); // Get current state from store
                        // CHECK 1: If data already exists → return immediately (no refetch)
                        if (state.categoryFilterTree.length > 0) {
                            return [
                                2,
                                state.categoryFilterTree
                            ];
                        }
                        // CHECK 2: If still fetching → return immediately (avoid duplicate fetch)
                        if (state.isLoading) {
                            return [
                                2,
                                state.categoryFilterTree
                            ];
                        }
                        _tmp = {};
                        // Start fetching
                        set((_tmp.isLoading = true, _tmp.isFetched = false, _tmp.error = null, _tmp));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,clients_MarketingClient__WEBPACK_IMPORTED_MODULE_0__/* .getCategoryFilterTree */ .CJ)()
                        ];
                    case 2:
                        res = _state.sent();
                        _tmp1 = {};
                        _tmp2 = {};
                        if (res.status === "OK") {
                            // Fetch successfully → save data to store
                            set((_tmp1.categoryFilterTree = res.data, _tmp1.isLoading = false, _tmp1.isFetched = true, _tmp1));
                            return [
                                2,
                                res.data
                            ];
                        } else {
                            set((_tmp2.error = "Failed to fetch category filter tree", _tmp2.isLoading = false, _tmp2.isFetched = true, _tmp2));
                            return [
                                2,
                                []
                            ];
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Failed to fetch category filter tree:", error);
                        _tmp3 = {};
                        set((_tmp3.error = error.message, _tmp3.isLoading = false, _tmp3.isFetched = true, _tmp3));
                        return [
                            2,
                            []
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }),
        // ============ HELPER FUNCTION ============
        // This function checks: if data exists then return it, if not then fetch
        getCategoryFilterTree: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            var state;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                state = get();
                if (state.categoryFilterTree.length > 0) {
                    return [
                        2,
                        state.categoryFilterTree
                    ]; // Data exists → return
                }
                return [
                    2,
                    state.fetchCategoryFilterTree()
                ]; // No data → fetch
            });
        }),
        // ============ RESET FUNCTION ============
        // Clear cache (used when user logs out or needs refresh)
        reset: function() {
            set({
                categoryFilterTree: [],
                isLoading: false,
                isFetched: false,
                error: null
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useCategoryFilterTree);


/***/ }),

/***/ 62667:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item_breadcrumb":"styles_item_breadcrumb__eYGFd","last_breadcrumb":"styles_last_breadcrumb__c7IQm"};

/***/ })

}]);